import { useEffect, useMemo } from "react"
import {
    getGenericSaveableWorkspacePageContent,
    getGenericWorkspacePage,
} from "panels/routing/WorkspaceRoutes"
import { useRouter } from "pages"
import { Outlet, useLocation } from "react-router"
import { TabHeader } from "themes/default-tailwind/buttons/TabHeader"
import {
    MissionGroupsSettingsGroupsTabContent,
    MissionGroupsSettingsGroupsTabFooter,
} from "./MissionGroupsSettingsGroupsTab"
import { MissionGroupsSettingsContactsTabContent } from "./MissionGroupsSettingsContactsTab"
import * as Icons from "@nova/component-icons"
import { Tooltip } from "panels/content/top-bar/TODO-put-in-package/Tooltip"

export const MissionGroupsSettingsPage = getGenericWorkspacePage({
    Header: MissionGroupsSettingsPageHeader,
    Content: MissionGroupsSettingsPageContent,
})

function MissionGroupsSettingsPageHeader() {
    return (
        <div className="w-full h-full flex items-center gap-2">
            <div className="text-[1.375rem] telegraf">Mission Groups</div>
            <div className="relative group/tooltip">
                <Icons.SmallIcon
                    Icon={Icons.Information}
                    className="text-gray-300 hover:text-gray-200"
                    onClick={(e) => e.stopPropagation()}
                />
                <Tooltip
                    title="Create mission groups to easily notify multiple people to watch Live Streams."
                    textClass="text-gray-0 text-center"
                    maxWidth={240}
                    placement="right"
                />
            </div>
        </div>
    )
}

function MissionGroupsSettingsPageContent() {
    const router = useRouter("/workspace/:workspaceId")
    const location = useLocation()
    const currentLocation = useMemo(() => {
        const groupsTab = router.preview({ path: "/settings/mission-groups/groups" })
        const savedContactsTab = router.preview({ path: "/settings/mission-groups/saved-contacts" })
        if (location.pathname === groupsTab) return "groups"
        if (location.pathname === savedContactsTab) return "contacts"
        return ""
    }, [location.pathname, router])
    return (
        <div className="w-full h-full flex flex-col gap-5 overflow-hidden">
            <div className="flex">
                <TabHeader
                    currentMode={currentLocation}
                    mode="groups"
                    setActiveMode={() =>
                        router.navigate({ path: "/settings/mission-groups/groups" })
                    }
                    title="Groups"
                />
                <TabHeader
                    currentMode={currentLocation}
                    mode="contacts"
                    setActiveMode={() =>
                        router.navigate({ path: "/settings/mission-groups/saved-contacts" })
                    }
                    title="Saved Contacts"
                />
                <div className="flex-1 border-b-2 border-b-white-200" />
            </div>
            <div className="grow overflow-hidden">
                <Outlet />
            </div>
        </div>
    )
}

export const MissionGroupsRedirect = () => {
    const router = useRouter("/workspace/:workspaceId")
    useEffect(() => {
        router.navigate({ path: "/settings/mission-groups/groups" }, { replace: true })
    }, [router])
    return null
}

export const MissionGroupsSettingsGroupsTabPage = getGenericSaveableWorkspacePageContent({
    Content: MissionGroupsSettingsGroupsTabContent,
    Footer: MissionGroupsSettingsGroupsTabFooter,
    scrollable: false,
})

export const MissionGroupsSettingsSavedContactsTabPage = () => {
    return (
        <div className="w-full h-full pb-6">
            <MissionGroupsSettingsContactsTabContent />
        </div>
    )
}
